<template lang="pug">
    .ui-content__item-page.ui-alert.ui-item-page
        h2.ui-item-page__title UI Alert
        .ui-block
            .row
                .col-lg-4.mb-30
                    h5.ui-item-page__sub-title Alert basic usage
                    vue-alert(title="Alert info")
                    vue-alert(title="Alert success" type="success")
                    vue-alert(title="Alert warning" type="warning")
                    vue-alert(title="Error alert" type="error")
                .col-lg-4.mb-30
                    h5.ui-item-page__sub-title Alert customizable close button
                    vue-alert(title='unclosable alert', type='success', :closable='false')
                    vue-alert(title='customized close-text', type='info', close-text='Gotcha')
                    vue-alert(title='alert with callback', type='warning', @close='hello')
                .col-lg-4.mb-30
                    h5.ui-item-page__sub-title Alert with icon
                    vue-alert(title='success alert', type='success', show-icon)
                    vue-alert(title='info alert', type='info', show-icon)
                    vue-alert(title='warning alert', type='warning', show-icon)
                    vue-alert(title='error alert', type='error', show-icon)
                .col-lg-4.mb-30
                    h5.ui-item-page__sub-title Alert center text
                    vue-alert(title='success alert', type='success', center, show-icon)
                    vue-alert(title='info alert', type='info', center, show-icon)
                    vue-alert(title='warning alert', type='warning', center, show-icon)
                    vue-alert(title='error alert', type='error', center, show-icon)
                .col-lg-4.mb-30
                    h5.ui-item-page__sub-title Alert with description
                    vue-alert(title='with description', type='success', description='This is a description.')
                .col-lg-4.mb-30
                    h5.ui-item-page__sub-title Alert with icon and description
                    vue-alert(title='success alert', type='success', description='more text description', show-icon)
                    vue-alert(title='info alert', type='info', description='more text description', show-icon)
                    vue-alert(title='warning alert', type='warning', description='more text description', show-icon)
                    vue-alert(title='error alert', type='error', description='more text description', show-icon)
                .col-lg-4.mb-30
                    h5.ui-item-page__sub-title Alert with icon and description
                    vue-alert(type='success' show-icon description='is')
                        slot(name="description")
                            span Вы не будете получать уведомление на email пока не подтвердить его
                            |&nbsp;
                            a.vue-alert__link(href="#") (ссылка)
                    vue-alert(title='info alert', type='info', description='more text description', show-icon)
                        slot(name="description")
                            span Вы не будете получать уведомление на email пока не подтвердить его
                            |&nbsp;
                            a.vue-alert__link(href="#") (ссылка)
                    vue-alert(title='warning alert', type='warning', description='more text description', show-icon)
                        slot(name="description")
                            span Вы не будете получать уведомление на email пока не подтвердить его
                            |&nbsp;
                            a.vue-alert__link(href="#") (ссылка)
                    vue-alert(title='error alert', type='error', description='more text description', show-icon)
                        slot(name="description")
                            span Вы не будете получать уведомление на email пока не подтвердить его
                            |&nbsp;
                            a.vue-alert__link(href="#") (ссылка)

</template>
<script>
    import vueAlert from '../../components/alert/main.vue'
    export default {
        name: 'ui-alerts',
        components: {
            vueAlert
        },
        methods: {
            hello() {
                console.log('hello')
            }
        }
    };
</script>
